import React from "react";
import { MDBTooltip } from "mdb-react-ui-kit";

const HeaderTicket = ({
  ticketName,
  wtNameLabel,
  deleteTicket,
  custID,
  error,
}) => {
  let iconDelete;
  if (wtNameLabel) {
    iconDelete = (
      <MDBTooltip tag="i" wrapperProps={{ href: "#" }} title="Delete">
        <i
          className="fa fa-trash mt-2"
          style={{ color: "#005580" }}
          onClick={() => deleteTicket(custID)}
        ></i>
      </MDBTooltip>
    );
  }
  return (
    <li
      className="list-group-item font-weight-bold"
      style={{
        backgroundColor: "#d9e6f2",
        borderRadius: "0px",
        borderBottomStyle: "dotted",
        borderTopStyle: "dotted",
      }}
    >
      <div className="form-inline">
        <div
          style={{
            width: "95%",
            ...(error ? { pointerEvents: "none", opacity: 0.6 } : {}),
          }}
        >
          {ticketName}
        </div>
        {iconDelete}
      </div>
    </li>
  );
};

export default HeaderTicket;
